import moment, { Moment } from 'moment-timezone'

type DateTimeRange = {
  from: string
  to: string
}

export class GetDateRangeFromPeriod {
  public execute(): DateTimeRange {
    const today = moment()
    const startDate = today.clone().startOf('month')
    const endDate = today.clone().endOf('day')

    const toDateString = (m: Moment) => m.format('YYYY-MM-DDTHH:mm:ssZ')

    return {
      from: toDateString(startDate),
      to: toDateString(endDate),
    }
  }
}
